import { render, staticRenderFns } from "./NotOrderingTabs.vue?vue&type=template&id=2bb1e082&scoped=true&"
import script from "./NotOrderingTabs.vue?vue&type=script&lang=js&"
export * from "./NotOrderingTabs.vue?vue&type=script&lang=js&"
import style0 from "./NotOrderingTabs.vue?vue&type=style&index=0&id=2bb1e082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1e082",
  null
  
)

export default component.exports